import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'

export function fetchExpenses(orderId) {
  return dispatch => {
    myGet(dispatch, servAddr + 'expense').then((response) => {
      dispatch({type: "FETCH_EXPENSES", payload: response.data.posts});
      dispatch({type: "FETCH_SRVCS", payload: response.data.srvcs});
      dispatch({type: "FETCH_SRVGS", payload: response.data.srvgs});
      dispatch({type: "FETCH_COMPS", payload: response.data.comps});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function filterExpenses(filter) {
  return {
    type: 'FILTER_EXPENSES',
    filter:filter
  };
}

export function sortExpenses(sort) {
  return {
    type: 'SORT_EXPENSES',
    sort:sort
  };
}

export function searchExpenses(search) {
  return {
    type: 'SEARCH_EXPENSES',
    search:search
  };
}

export function editExpense(post, cb = () => {}) {
  return dispatch => {
    myPost(dispatch, servAddr + 'expense', {data: post}).then((response) => {
      cb();
      if (post.post_id) {
        dispatch({
          type: "EDIT_EXPENSE",
          payload: {
            ...post,
            post_price: parseFloat(("" + post.post_price).replace(',','.'),10),
            post_qntt: parseFloat(("" + post.post_qntt).replace(',','.'),10)
          }
        });
      }
      else {
        dispatch({
          type: "CREATE_EXPENSE",
          payload: {
            ...post,
            post_price: parseFloat(("" + post.post_price).replace(',','.'),10),
            post_qntt: parseFloat(("" + post.post_qntt).replace(',','.'),10),
            post_id: response.data.id
          }
        });
        if(post.pmnt_add === 1){
          dispatch({
            type: "CREATE_EXPENSE",
            payload: {
              ...post,
              post_price: parseFloat(("" + post.post_price).replace(',','.'),10),
              post_qntt: parseFloat(("" + post.post_qntt).replace(',','.'),10),
              post_id: response.data.pmnt_id,
              post_payed: post.pmnt_payed,
              post_bdate: post.pmnt_bdate,
              post_srvc_id: post.pmnt_srvc_id,
              post_link: response.data.id
            }
          });
        }
      }
    }, (err) => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/expenseActions.js